import { Grid } from '@chakra-ui/react';
import React from 'react';

import useIsMobile from 'lib/hooks/useIsMobile';
import { useI18n } from 'lib/i18n/context';
import ActionBar from 'ui/shared/ActionBar';
import DataListDisplay from 'ui/shared/DataListDisplay';
import Pagination from 'ui/shared/pagination/Pagination';
import type { QueryWithPagesResult } from 'ui/shared/pagination/useQueryWithPages';

import { ADDRESS_TOKEN_KEYS } from '../i18n';
import NFTItem from './NFTItem';

type Props = {
  tokensQuery: QueryWithPagesResult<'address_nfts'>;
  hasActiveFilters: boolean;
};

const AddressNFTs = ({ tokensQuery, hasActiveFilters }: Props) => {
  const isMobile = useIsMobile();
  const { t } = useI18n();

  const { isError, isPlaceholderData, data, pagination } = tokensQuery;

  const actionBar = isMobile && pagination.isVisible && (
    <ActionBar mt={ 2 } mb={ 2 }>
      <Pagination ml="auto" { ...pagination }/>
    </ActionBar>
  );

  const content = data?.items ? (
    <Grid
      w="100%"
      columnGap={{ base: 3, lg: 6 }}
      rowGap={{ base: 3, lg: 6 }}
      gridTemplateColumns={{ base: 'repeat(2, calc((100% - 12px)/2))', lg: 'repeat(auto-fill, minmax(210px, 1fr))' }}
    >
      { data.items.map((item, index) => {
        const key = item.token.address + '_' + (item.id && !isPlaceholderData ? `id_${ item.id }` : `index_${ index }`);

        return (
          <NFTItem
            key={ key }
            { ...item }
            isLoading={ isPlaceholderData }
            withTokenLink
          />
        );
      }) }
    </Grid>
  ) : null;

  return (
    <DataListDisplay
      isError={ isError }
      items={ data?.items }
      emptyText={ t(ADDRESS_TOKEN_KEYS.empty.selectedType) }
      content={ content }
      actionBar={ actionBar }
      filterProps={{
        emptyFilteredText: t(ADDRESS_TOKEN_KEYS.empty.filteredToken),
        hasActiveFilters,
      }}
    />
  );
};

export default AddressNFTs;
